import React from 'react'

import './Ellipsis.scss'

const Ellipsis = ({ children }) => (
  <>
    { children }
    <span data-qa="ellipsis" className="ellipsis">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  </>
)

export default Ellipsis
